import { Orbit } from "./Orbit.js";
export class CachedOrbit extends Orbit {
    positionsCache;
    BoundingRadiusSlack = 1.2;
    constructor() {
        super();
        this.positionsCache = new Map();
    }
    positionAtTime(jd) {
        const cached = this.positionsCache.get(jd);
        if (cached)
            return cached;
        const position = this.computePosition(jd);
        this.positionsCache.set(jd, position);
        return position;
    }
}
